/**
 * A tiny utility to generate actions and a reducer in one place.
 * Great for reducing all the strings you need to write for traditional actions.
 * The reducer names ARE the action names.
 */
export function createSimpleSlice({ name, initialState, reducers }) {
  const actions = {};

  // Generate action creators automatically based on the keys in 'reducers'
  Object.keys(reducers).forEach(key => {
    actions[key] = payload => ({
      type: `${name}/${key}`,
      payload,
    });
  });

  const reducer = (state = initialState, action) => {
    const [sliceName, actionType] = action.type.split('/');

    if (sliceName === name && reducers[actionType]) {
      // Note: You must return new state manually (no Immer here!)
      return reducers[actionType](state, action.payload);
    }
    return state;
  };

  return { actions, reducer };
}
